import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-447810c9"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "ap-page-filter section-part"
}
const _hoisted_2 = { class: "filter-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.hasFilterSlot)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "filter-tabs", {}, undefined, true),
          _createElementVNode("div", _hoisted_2, [
            _renderSlot(_ctx.$slots, "filter", {}, undefined, true)
          ])
        ]))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "before", {}, undefined, true),
    _createElementVNode("div", {
      class: _normalizeClass(["ap-block ap-page-content", _ctx.contentClass])
    }, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ], 2),
    _renderSlot(_ctx.$slots, "after", {}, undefined, true)
  ]))
}